import { gql } from 'apollo-angular';

export const FRONTEND_CASE_COMPONENTS_QUERY = gql`
  query caseComponents($caseId: UUID!) {
    case(id: $caseId) {
      id
      caseComponents {
        id
        name
        required
        shortName
        docType
        hideFromApplicant
        allowedLanguages
        canSpecifyLanguage
        serviceTranslationAvailable
        isVitalDocument
        component {
          id
          type
          name
          instructionHtml
          instructionImage
        }
        optedOut
        useRelation
        specificTo
        displayName
        applicantDetails
        uploadedDocuments {
          id
          created
          modified
          file
          fileName
          translatedFile
          translatedFileName
          translatedFileUsePlaceholder
          language
          needsTranslation
          displayOrder
          translationOrder {
            orderId
            orderNumber
            status
            statusDisplay
          }
        }
        case {
          id
          applicant {
            id
          }
        }
      }
    }
  }
`;

export const FRONTEND_UPDATE_CASE_STEPS_MUTATION = gql`
  mutation updateCaseSteps($caseId: UUID!, $completedStep: Int, $lastStep: Int) {
    updateCaseSteps(id: $caseId, completedStep: $completedStep, lastStep: $lastStep) {
      case {
        id
        completedStep
        lastStep
      }
    }
  }
`;

export const FRONTEND_UPDATE_CASE_ATTORNEY_REVIEW_TERMS_MUTATION = gql`
  mutation updateCaseAttorneyReviewTerms($caseId: UUID!, $attorneyReviewTerms: Boolean) {
    updateCaseAttorneyReviewTerms(id: $caseId, attorneyReviewTerms: $attorneyReviewTerms) {
      case {
        id
        attorneyReviewTerms
      }
    }
  }
`;
